import React from 'react';
import styled from 'styled-components';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { ChartCard } from './ChartCard';
import { colors } from '../../theme/tokens';
import {
  DEMO_YOY_ARTICLES,
  DEMO_YOY_SOURCES,
  DEMO_YOY_GROWTH
} from './demoData';

const DEMO_ARTICLES = DEMO_YOY_ARTICLES;
const DEMO_SOURCES = DEMO_YOY_SOURCES;
const GROWTH_DATA = DEMO_YOY_GROWTH;

export const YearOverYearCard: React.FC = () => (
  <ChartCard
    title="Comparaison annuelle"
    subtitle="Comparaison année par année pour chaque client"
  >
    <Row>
      <HalfCol>
        <ColTitle>Évolution des Articles</ColTitle>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={DEMO_ARTICLES}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--line)" />
            <XAxis
              dataKey="client"
              tick={{ fontSize: 11, fill: colors.inkMuted }}
            />
            <YAxis width={40} tick={{ fontSize: 11, fill: colors.inkMuted }} />
            <Tooltip />
            <Legend />
            <Bar dataKey="2025" fill={colors.indigo} />
            <Bar dataKey="2026" fill={colors.olive} />
          </BarChart>
        </ResponsiveContainer>
      </HalfCol>

      <HalfCol>
        <ColTitle>Évolution des Sources</ColTitle>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={DEMO_SOURCES}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--line)" />
            <XAxis
              dataKey="client"
              tick={{ fontSize: 11, fill: colors.inkMuted }}
            />
            <YAxis width={40} tick={{ fontSize: 11, fill: colors.inkMuted }} />
            <Tooltip />
            <Legend />
            <Bar dataKey="2025" fill={colors.indigo} />
            <Bar dataKey="2026" fill={colors.olive} />
          </BarChart>
        </ResponsiveContainer>
      </HalfCol>
    </Row>

    <GrowthGrid>
      {GROWTH_DATA.map((item) => (
        <GrowthCard key={item.label}>
          <GrowthLabel>{item.label}</GrowthLabel>
          <GrowthRow>
            <GrowthStat>
              <GrowthStatLabel>Croissance Articles</GrowthStatLabel>
              <GrowthValue $positive={item.articleGrowth >= 0}>
                {item.articleGrowth >= 0 ? '+' : ''}
                {item.articleGrowth.toFixed(1)}%
              </GrowthValue>
            </GrowthStat>
            <GrowthStat>
              <GrowthStatLabel>Croissance Sources</GrowthStatLabel>
              <GrowthValue $positive={item.sourceGrowth >= 0}>
                {item.sourceGrowth >= 0 ? '+' : ''}
                {item.sourceGrowth.toFixed(1)}%
              </GrowthValue>
            </GrowthStat>
          </GrowthRow>
        </GrowthCard>
      ))}
    </GrowthGrid>
  </ChartCard>
);

// --- Styled ---

const Row = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

const HalfCol = styled.div`
  flex: 1;
  min-width: 280px;
`;

const ColTitle = styled.h4`
  font-family: var(--font-sans-semibold, var(--font-sans));
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 10px;
`;

const GrowthGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
`;

const GrowthCard = styled.div`
  padding: 12px 16px;
  background: var(--paper);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
`;

const GrowthLabel = styled.p`
  font-family: var(--font-sans-semibold, var(--font-sans));
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 6px;
`;

const GrowthRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const GrowthStat = styled.div``;

const GrowthStatLabel = styled.p`
  font-family: var(--font-sans);
  font-size: 12px;
  color: var(--ink-muted);
  margin: 0;
`;

const GrowthValue = styled.p<{ $positive: boolean }>`
  font-family: var(--font-mono);
  font-size: 16px;
  font-weight: 600;
  color: ${(p) => (p.$positive ? colors.olive : colors.crimson)};
  margin: 2px 0 0;
`;
